/**
 * @module helpers/affirm/config
 * @description Supported values for Affirm
 * @see {@link https://docs.affirm.com/developers/v1.0-Global-Integration/docs/global-affirm-integration-guide#supported-values|Affirm Supported Values}
 */

const affirmConfig = window?.envSettings?.ITFE_PRODUCT_PAGE_AFFIRM_CONFIG || {}; // Via Contentful
const currentLocaleRaw = window?.GarminAppBootstrap?.locale;

// Normalize a locale string to "xx_XX" format. - Affirm needs this manipulation
const normalizeLocale = (locale) => {
  if (!locale) return '';

  const [lang, countryCode] = locale.replace('-', '_').split('_');

  return `${lang.toLowerCase()}_${countryCode.toUpperCase()}`;
};

// Find matching Affirm configuration for the current locale.
const match = Object.entries(affirmConfig)
  .flatMap(([countryCode, locales]) => Object.entries(locales).map(([localeKey, config]) => ({
    countryCode,
    localeKey,
    config,
  })))
  .find(({
    localeKey,
  }) => normalizeLocale(localeKey) === normalizeLocale(currentLocaleRaw));

export const affirmSupportedCountryCode = match?.countryCode || '';

export const affirmSupportedLocale = match?.localeKey ? normalizeLocale(match.localeKey) : '';

export const affirmPublicApiKey = match?.config?.AFFIRM_PUBLIC_API_KEY || '';

export const affirmScript = match?.config?.AFFIRM_SCRIPT || '';

export const affirmPriceRange = match?.config?.AFFIRM_PRICE_RANGE || {};

export const isAffirmLocale = (locale) => normalizeLocale(locale) === affirmSupportedLocale;

/**
 * Helper function to convert a price to cents needed for Affirm
 * @param {number} price - The price to convert to cents
 * @returns {number}     - The price in cents, or null if input is invalid
 * @example
 * affirmPriceToCents(100) // 10000
 * affirmPriceToCents(100.50) // 10050
 * affirmPriceToCents(null) // null
 * affirmPriceToCents(undefined) // null
 */
export const affirmPriceToCents = (price) => (price === null || price === undefined ? null : price * 100);
